import { Check } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";
import { BRAND } from "@/lib/site";
import { SignupBox } from "@/components/site/SignupBox";
import { freebieTitle, useFreebie } from "@/hooks/useFreebie";

export default function FreePrintablePage() {
  const f = useFreebie();
  const title = freebieTitle(f);
  const raw = title.replace(/^(a free |\d+ free )/i, "");
  const name = raw.charAt(0).toUpperCase() + raw.slice(1);
  usePageMeta(`Free printable: ${name} | ${BRAND}`, `Get ${title} by email. Print at home, fill in or color, and give.`);
  return (
    <div className="mx-auto grid max-w-5xl items-center gap-10 px-5 pt-14 sm:px-8 lg:grid-cols-[1fr_1fr]" data-testid="free-printable-page">
      <div>
        <p className="mb-2 text-xs font-extrabold uppercase tracking-[0.2em] text-[#23324A]/60">This season's free printable</p>
        <h1 className="font-heading text-4xl font-semibold text-[#23324A] sm:text-5xl" data-testid="freebie-title">{name}</h1>
        <p className="mt-4 text-[#23324A]/80">Join the list and I'll email you {title}. It changes with the seasons, so there's always something new to print. Print at 100% on cardstock or regular paper.</p>
        <ul className="mt-6 space-y-2 text-sm font-semibold text-[#23324A]">
          {["Ready to print at home", "US Letter (A4 link included in the email)", "Sent straight to your inbox"].map((t) => (
            <li key={t} className="flex items-center gap-2"><Check className="h-4 w-4 text-[#D9785C]" strokeWidth={3} />{t}</li>
          ))}
        </ul>
        <div className="mt-8"><SignupBox source="free-printable" compact /></div>
      </div>
      {f && <img src={`${process.env.REACT_APP_BACKEND_URL}${f.preview}`} alt={`Preview of ${title}`} className="mx-auto w-full max-w-sm -rotate-2 rounded-lg bg-white shadow-2xl" data-testid="freebie-preview" />}
    </div>
  );
}
